/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<circle
				opacity="0.4"
				cx="14"
				cy="9"
				r="2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 17L11.7627 14.7627C10.9707 13.9707 10.5747 13.5747 10.118 13.4263C9.71635 13.2958 9.28365 13.2958 8.88197 13.4263C8.42531 13.5747 8.02929 13.9707 7.23726 14.7627L5 17L4.5 17.5M14 17L14.7373 16.2627C15.5293 15.4707 15.9253 15.0747 16.382 14.9263C16.7837 14.7958 17.2163 14.7958 17.618 14.9263C18.0747 15.0747 18.4707 15.4707 19.2627 16.2627L20 17M14 17L17 20M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M16.0001 9C16.0001 10.1046 15.1047 11 14.0001 11C12.8956 11 12.0001 10.1046 12.0001 9C12.0001 7.89543 12.8956 7 14.0001 7C15.1047 7 16.0001 7.89543 16.0001 9Z"
					fill="currentColor"
				/>
				<path
					d="M14.0001 17L11.7628 14.7627C10.9708 13.9707 10.5747 13.5747 10.1181 13.4263C9.7164 13.2958 9.2837 13.2958 8.88202 13.4263C8.42536 13.5747 8.02934 13.9707 7.23731 14.7627L3.99963 18.0004C5.82407 20.4291 8.7286 22 12.0001 22C13.9938 22 15.8513 21.4165 17.4111 20.411L14.0001 17Z"
					fill="currentColor"
				/>
				<path
					d="M19.2628 16.2627C18.4708 15.4707 18.0747 15.0747 17.6181 14.9263C17.2164 14.7958 16.7837 14.7958 16.382 14.9263C15.9254 15.0747 15.5293 15.4707 14.7373 16.2627L14.0001 17L17.4111 20.411C18.6122 19.6367 19.6368 18.6121 20.4111 17.411L19.2628 16.2627Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M14 17L11.7627 14.7627C10.9707 13.9707 10.5747 13.5747 10.118 13.4263C9.71635 13.2958 9.28365 13.2958 8.88197 13.4263C8.42531 13.5747 8.02929 13.9707 7.23726 14.7627L5 17L4.5 17.5M14 17L14.7373 16.2627C15.5293 15.4707 15.9253 15.0747 16.382 14.9263C16.7837 14.7958 17.2163 14.7958 17.618 14.9263C18.0747 15.0747 18.4707 15.4707 19.2627 16.2627L20 17M14 17L17 20M16 9C16 10.1046 15.1046 11 14 11C12.8954 11 12 10.1046 12 9C12 7.89543 12.8954 7 14 7C15.1046 7 16 7.89543 16 9ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM13.9999 11.0001C15.1045 11.0001 15.9999 10.1046 15.9999 9.00007C15.9999 7.8955 15.1045 7.00007 13.9999 7.00007C12.8954 7.00007 11.9999 7.8955 11.9999 9.00007C11.9999 10.1046 12.8954 11.0001 13.9999 11.0001ZM15 14.9393C15.5452 14.394 15.8179 14.1214 16.112 13.9757C16.6715 13.6984 17.3285 13.6984 17.888 13.9757C18.1821 14.1214 18.4548 14.394 19 14.9393L19.2531 15.1924C19.5388 15.4781 19.6816 15.6209 19.7579 15.813C19.8206 15.971 19.8426 16.195 19.812 16.3622C19.7747 16.5655 19.6795 16.7081 19.489 16.9932C17.8751 19.409 15.1234 21 12 21C9.17957 21 6.66215 19.7026 5.01198 17.6721C4.77562 17.3813 4.65745 17.2359 4.6038 17.0186C4.56107 16.8455 4.57329 16.6083 4.63358 16.4406C4.70928 16.23 4.8654 16.0739 5.17764 15.7616L7.23726 13.702C8.02929 12.91 8.42531 12.514 8.88197 12.3656C9.28365 12.2351 9.71635 12.2351 10.118 12.3656C10.5747 12.514 10.9707 12.91 11.7627 13.702L13 14.9393C13.2726 15.2119 13.4089 15.3482 13.556 15.4211C13.8358 15.5597 14.1642 15.5597 14.444 15.4211C14.5911 15.3482 14.7274 15.2119 15 14.9393Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M7 20.6622C8.47087 21.513 10.1786 22 12 22C13.9938 22 15.8512 21.4165 17.411 20.411M14 17L12.3284 15.3284C10.9951 13.9951 10.3284 13.3284 9.5 13.3284C8.67157 13.3284 8.00491 13.9951 6.67157 15.3284L5.95456 16.0452C5.32489 16.6747 5.01005 16.9895 4.55698 17.076C4.21736 17.1408 3.70423 17.0319 3.42023 16.8347C3.04135 16.5716 2.91539 16.2442 2.66348 15.5893C2.2349 14.4752 2 13.2651 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.9938 21.4165 15.8512 20.411 17.411M14 17L17.411 20.411M14 17C14.7745 16.2255 15.7854 14.8284 17 14.8284C18.4464 14.8284 19.4771 16.4771 20.411 17.411M20.411 17.411C19.6367 18.6121 18.6121 19.6367 17.411 20.411M16 9C16 10.1046 15.1046 11 14 11C12.8954 11 12 10.1046 12 9C12 7.89543 12.8954 7 14 7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M14 17L11.7627 14.7627C10.9707 13.9707 10.5747 13.5747 10.118 13.4263C9.71635 13.2958 9.28365 13.2958 8.88197 13.4263C8.42531 13.5747 8.02929 13.9707 7.23726 14.7627L5 17L4.5 17.5M14 17L14.7373 16.2627C15.5293 15.4707 15.9253 15.0747 16.382 14.9263C16.7837 14.7958 17.2163 14.7958 17.618 14.9263C18.0747 15.0747 18.4707 15.4707 19.2627 16.2627L20 17M14 17L17 20M16 9C16 10.1046 15.1046 11 14 11C12.8954 11 12 10.1046 12 9C12 7.89543 12.8954 7 14 7C15.1046 7 16 7.89543 16 9ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z"
				fill="currentColor"
			/>
			<path
				d="M20.4958 16.4349C20.8014 16.7405 20.9542 16.8933 21.0303 17.0948C21.0919 17.2581 21.1094 17.4806 21.0739 17.6515C21.0301 17.8624 20.9192 18.0147 20.6974 18.3195C18.743 21.0046 15.5753 22.75 12.0001 22.75C8.71756 22.75 5.77868 21.2788 3.80685 18.9598C3.54719 18.6544 3.41735 18.5017 3.35943 18.2819C3.31263 18.1043 3.32216 17.8684 3.38313 17.6951C3.45859 17.4807 3.62121 17.3181 3.94645 16.9929L7.23736 13.7019C8.0294 12.9099 8.42541 12.5139 8.88207 12.3655C9.28376 12.235 9.71645 12.235 10.1181 12.3655C10.5748 12.5139 10.9708 12.9099 11.7628 13.702L13.0001 14.9392C13.2727 15.2118 13.409 15.3481 13.5561 15.421C13.8359 15.5597 14.1643 15.5597 14.4441 15.421C14.5912 15.3481 14.7275 15.2118 15.0001 14.9392C15.5454 14.394 15.818 14.1213 16.1121 13.9756C16.6716 13.6983 17.3286 13.6983 17.8881 13.9756C18.1822 14.1213 18.4549 14.394 19.0001 14.9392L20.4958 16.4349Z"
				fill="currentColor"
			/>
			<path
				d="M16.0001 9C16.0001 10.1046 15.1046 11 14.0001 11C12.8955 11 12.0001 10.1046 12.0001 9C12.0001 7.89543 12.8955 7 14.0001 7C15.1046 7 16.0001 7.89543 16.0001 9Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
